// react core
import { useContext, useState } from "react";

// linkify highlighting
import Linkify from "react-linkify";

// material design
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";

// fonts and icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt as iconDelete } from "@fortawesome/pro-solid-svg-icons";
import { faClose as iconClose } from "@fortawesome/pro-solid-svg-icons";
import { faCircle as iconCircle } from "@fortawesome/pro-solid-svg-icons";
import { faHandPointer as iconPointer } from "@fortawesome/pro-solid-svg-icons";
import { faReply as iconReplyPost } from "@fortawesome/pro-thin-svg-icons";
import { faEllipsisV as iconActions } from "@fortawesome/pro-solid-svg-icons";
import { faFlag as iconReport } from "@fortawesome/pro-solid-svg-icons";
// import { faBan as iconDisabled } from "@fortawesome/pro-solid-svg-icons";
// import { faMessageArrowUpRight as iconArrow } from "@fortawesome/pro-solid-svg-icons";
// import { faClock as iconAge } from "@fortawesome/pro-duotone-svg-icons";
// import { faCommentAlt as iconPost } from "@fortawesome/pro-duotone-svg-icons";
// import { faImage as iconImage } from "@fortawesome/pro-duotone-svg-icons";

// entzy config and components
import configEntzy from "components/config/ConfigEntzy";
import { MainContext } from "components/main/MainContext";
import ActionCore from "../actions/ActionCore";
import { UserAvatar } from "components/utils/common/CommonAvatars";
import { ActionLoader } from "components/utils/common/CommonLoaders";
import { ActionButton } from "components/utils/common/CommonButtons";
import {
  ContentWarningHeaderTag,
  ContentWarningTag,
} from "components/utils/common/CommonTags";
import { getAge, jsonTryParse } from "models/Tools";

// entzy hooks
import { useMediaImage } from "hooks/media/mediaImage";

const PostControls = (props) => {
  const showConfirmDelete =
    props.canRemove && props.removing === props.item.PostId;
  const showReply =
    props.item &&
    props.item.RoomName &&
    props.item.RoomName.startsWith("desk") &&
    props.item.Category === "runner"
      ? false
      : props.showReply;
  const [showActions, setShowActions] = useState(false);
  const [showReport, setShowReport] = useState(null);

  const handleShowActions = () => {
    setShowActions(!showActions);
  };

  const handleReport = (post) => {
    setShowReport(
      showReport && showReport.PostId === post.PostId ? null : post
    );
  };

  const getSubmitReportMailTo = (post) => {
    const mailtoLink = `mailto:${configEntzy.CONTACT_EMAIL_SUPPORT}?subject=Report Message&body=I would like to report the following message:%0D%0A%0D%0ARoomId: ${post.RoomId}%0D%0APostId: ${post.PostId}%0D%0AUserId: ${post.UserId}%0D%0A%0D%0APlease review this message for potential violations of community guidelines.%0D%0AThank you.`;
    return mailtoLink;
  };

  return (
    <Box
      className="box-default"
      sx={{
        borderTop: "1px solid #111",
      }}
    >
      <Box
        className="box-default text-left action-pointer"
        sx={{
          p: configEntzy.APP_SPACING_SM2X,
        }}
        onClick={handleShowActions}
        hidden={showConfirmDelete}
      >
        <Typography variant="subtitle2" color="primary" noWrap>
          <span
            style={{
              float: showActions ? "right" : "left",
            }}
          >
            <FontAwesomeIcon
              icon={showActions ? iconClose : iconActions}
              fixedWidth
            />
          </span>
          {!showActions && (
            <span>
              <span>
                &nbsp;
                {props.item.preload ? (
                  props.item.alert ? (
                    <span
                      style={{
                        backgroundColor: "darkred",
                        color: "white",
                        padding: "2px 8px",
                        borderRadius: "8px",
                      }}
                    >
                      Heads Up!
                    </span>
                  ) : (
                    <span
                      style={{
                        backgroundColor: "orange",
                        color: "black",
                        padding: "2px 8px",
                        borderRadius: "8px",
                      }}
                    >
                      Sending...
                    </span>
                  )
                ) : props.memberMessaging ? (
                  "DM"
                ) : props.notification ? (
                  "Edit"
                ) : (
                  <span className="proper-case">{props.item.Category}</span>
                )}
                &nbsp;
              </span>
              {props.notification && !props.item.MessageRead && (
                <span
                  style={{
                    float: "right",
                  }}
                >
                  &nbsp;&nbsp;
                  <span className="pd2 bg-highlight rounded">
                    &nbsp;Unread&nbsp;
                  </span>
                </span>
              )}

              <span
                style={{
                  float: "right",
                }}
              >
                {getAge({ timestamp: props.item.LastUpdated })}
              </span>
            </span>
          )}
        </Typography>
        {props.item.preload && props.item.alert && (
          <Typography
            variant="body2"
            color="danger.dark"
            sx={{
              mt: configEntzy.APP_SPACING_SM,
            }}
          >
            {props.item.message}
          </Typography>
        )}
      </Box>
      <Box
        className="box-default nooverflow"
        hidden={showConfirmDelete || !showActions}
        sx={{
          p: configEntzy.APP_SPACING_SM,
          backgroundColor: "dusk.dark",
          borderBottomLeftRadius: showReport ? 0 : configEntzy.BORDER_SIZE_LG,
          borderBottomRightRadius: showReport ? 0 : configEntzy.BORDER_SIZE_LG,
        }}
      >
        <Box
          className="box-inline left"
          sx={{ mr: configEntzy.APP_SPACING_SM }}
        >
          <ActionButton
            variant="outlined"
            size="small"
            color="danger"
            fullWidth={true}
            disableElevation={true}
            text={
              <span>
                <FontAwesomeIcon
                  icon={showReport ? iconClose : iconReport}
                  transform="grow-4"
                />
              </span>
            }
            onClick={() => handleReport(props.item)}
          />
        </Box>
        <Box
          className="box-inline left"
          sx={{ mr: configEntzy.APP_SPACING_SM }}
        >
          <ActionButton
            variant="outlined"
            size="small"
            color="danger"
            fullWidth={true}
            disabled={props.canRemove ? false : true}
            disableElevation={true}
            text={
              <span>
                <FontAwesomeIcon icon={iconDelete} transform="grow-4" />
              </span>
            }
            onClick={() => props.handleRemoving(props.item.PostId)}
          />
        </Box>
        {showReply && props.memberMessaging && (
          <Box
            className="box-inline right"
            sx={{
              ml: configEntzy.APP_SPACING_SM,
              borderRadius: configEntzy.BORDER_SIZE_XL,
            }}
          >
            <ActionButton
              variant="contained"
              size="small"
              color="night"
              fullWidth={true}
              border={true}
              disableElevation={true}
              text={
                <span>
                  <span>Reply&nbsp;&nbsp;</span>
                  <FontAwesomeIcon icon={iconReplyPost} transform="grow-4" />
                </span>
              }
              onClick={() => props.handlePostMemberMessage(props.item.PostId)}
            />
          </Box>
        )}

        {showReply && !props.memberMessaging && (
          <Box
            className="box-inline right"
            sx={{
              ml: configEntzy.APP_SPACING_SM,
              borderRadius: configEntzy.BORDER_SIZE_XL,
            }}
          >
            <ActionCore
              {...props}
              room="messaging"
              subAction="post"
              actionText="Reply"
              actionParams={{
                inReplyTo: props.item.PostId,
                inReplyUserId: props.item.UserId,
              }}
              icon={iconReplyPost}
              mini={true}
              popMini={true}
              fullWidth={true}
              disabled={showReply ? false : true}
              disableGlow={true}
              disableElevation={true}
              color="night"
              border={true}
              noMask={true}
            />
          </Box>
        )}
      </Box>
      <Box className="box-default" hidden={!showConfirmDelete}>
        <Box
          className="box-inline left text-left action-pointer"
          sx={{
            p: configEntzy.APP_SPACING_MD,
          }}
          onClick={() => props.handleRemove(props.item)}
        >
          <Typography variant="subtitle2" color="danger.dark">
            {props.canRemove ? (
              <span>
                <FontAwesomeIcon icon={iconDelete} />
                <span>&nbsp;&nbsp;&nbsp;</span>
                <span style={{ opacity: 0.5 }}>Confirm Delete?</span>
              </span>
            ) : (
              <span>&nbsp;</span>
            )}
          </Typography>
        </Box>
        <Box
          className="box-inline right text-right action-pointer"
          sx={{
            p: configEntzy.APP_SPACING_MD,
          }}
          onClick={() => props.handleRemoving(null)}
        >
          <Typography variant="subtitle2">
            {props.canRemove ? (
              <span>
                <FontAwesomeIcon icon={iconClose} />
              </span>
            ) : (
              <span> &nbsp; </span>
            )}
          </Typography>
        </Box>
      </Box>
      <Box
        className="box-default"
        sx={{
          p: configEntzy.APP_SPACING_SM,
          backgroundColor: "dusk.dark",
          borderBottomLeftRadius: configEntzy.BORDER_SIZE_LG,
          borderBottomRightRadius: configEntzy.BORDER_SIZE_LG,
        }}
        hidden={!showReport}
      >
        <Box
          className="box-default"
          sx={{
            p: configEntzy.APP_SPACING_MD,
            borderRadius: configEntzy.BORDER_SIZE_LG,
          }}
        >
          <Box className="box-default">
            <Typography variant="subtitle2" color="danger.dark">
              <FontAwesomeIcon icon={iconReport} />
            </Typography>
            <Typography variant="subtitle2" color="danger.light">
              Report Message
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{ mt: configEntzy.APP_SPACING_MD }}
            >
              If you believe this message violates our community guidelines, or
              if there is any other issue, you can report it to our moderation
              team for review at {configEntzy.CONTACT_EMAIL_SUPPORT}.
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{ mt: configEntzy.APP_SPACING_MD }}
            >
              To block this user from messaging you, tap on their avatar to open
              DMs and access notification settings (bell icon at the top).
            </Typography>
          </Box>
          <Box
            className="box-default"
            sx={{ mt: configEntzy.APP_SPACING_MD2X }}
          >
            <Button
              component="a"
              variant="contained"
              size="small"
              sx={{
                backgroundColor: "darkred",
                color: "white",
                width: "100%",
                borderRadius: configEntzy.BORDER_SIZE_XL,
              }}
              href={getSubmitReportMailTo(props.item)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>
                <span>&nbsp;&nbsp;</span>
                <span>Submit Report</span>
                <span>&nbsp;&nbsp;</span>
              </span>
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export const MessageUser = (props) => {
  return (
    <Box className="box-default">
      <Box
        className="box-inline"
        sx={{
          color: props.light ? "white" : undefined,
        }}
      >
        <UserAvatar
          user={{ identity: props.identity }}
          size="sm"
          light={props.light}
          nameOnly={props.nameOnly}
          nameHideInfo={props.nameHideInfo}
        />
      </Box>
    </Box>
  );
};

export const MessagePost = (props) => {
  const user = props.user;
  const loadingId = props.loadingId;
  const canRemove =
    // props.memberMessaging ||
    props.manager || props.message.UserId === props.user.identity;

  // json parse moderation if exists
  if (
    props.message.ContentModeration &&
    !props.message.ContentModeration.status
  ) {
    props.message.ContentModeration = jsonTryParse(
      props.message.ContentModeration,
      {
        status: "fail",
      }
    );
  }

  const mainContext = useContext(MainContext);

  const [popMessage, setPopMessage] = useState(null);
  const [showModerated, setShowModerated] = useState(null);

  const handlePopMessage = async (message) => {
    setPopMessage(message.PostId);
  };
  const handleClosePopMessage = () => {
    setPopMessage(null);
  };

  const handleShowModerated = (id) => {
    setShowModerated(showModerated === id ? null : id);
  };

  // hook to load image
  const mediaImage = useMediaImage(
    props.message.ContentImage &&
      props.message.ContentImage !== configEntzy.EMPTY_STRING_SET &&
      props.message.ContentImage !== configEntzy.EMPTY_STRING_SHORTSET
      ? {
          user: user,
          context: mainContext,
          image: {
            id: "event:messages:image:" + props.message.PostId,
            key: props.message.ContentImage,
          },
        }
      : null
  );

  return (
    <Box className="box-default">
      <Box
        className={
          props.message.Category === "runner"
            ? "box-inline left"
            : "box-inline right"
        }
        sx={{
          width: "60%",
        }}
      >
        <Box className="box-default">
          {/* ----- loader ----- */}
          {loadingId === props.message.PostId && (
            <Box className="box-default zero-height text-center">
              <Box
                className="box-default"
                sx={{
                  pt: configEntzy.APP_SPACING_SM,
                }}
              >
                <ActionLoader size="md" color="secondary" />
              </Box>
            </Box>
          )}
          {/* message display */}
          {props.message.PostDeleted ? (
            <Box
              className="box-default bg-black-t10"
              sx={{
                p: configEntzy.APP_SPACING_MD,
                borderRadius: configEntzy.BORDER_SIZE_XL,
              }}
            >
              <Typography variant="subtitle2">
                <em>(message deleted)</em>
              </Typography>
            </Box>
          ) : (
            <Box
              className="box-default shadow-darkest bg-black-t50 nooverflow"
              sx={{
                backgroundColor: "dusk.main",
                borderRadius: configEntzy.BORDER_SIZE_XL,
              }}
            >
              <Box
                className="box-default action-pointer"
                onClick={() => handlePopMessage(props.message)}
              >
                {/* list view message text */}
                <Box
                  className="box-default nooverflow"
                  sx={{
                    pt: configEntzy.APP_SPACING_MD,
                    pl: configEntzy.APP_SPACING_MD,
                    pr: configEntzy.APP_SPACING_MD,
                    pb: configEntzy.APP_SPACING_MD2X,
                    maxHeight: configEntzy.AVATAR_SIZE_LG,
                    maskImage: "linear-gradient(180deg, #000 60%, transparent)",
                  }}
                >
                  {props.message.parent && (
                    <Box
                      className="box-default"
                      sx={{
                        backgroundColor: "black",
                        p: configEntzy.APP_SPACING_SM2X,
                        mb: configEntzy.APP_SPACING_SM2X,
                        borderRadius: configEntzy.BORDER_SIZE_XL,
                        textAlign:
                          props.message.Category === "runner"
                            ? "left"
                            : "right",
                      }}
                    >
                      <Box
                        className="box-default"
                        sx={{
                          borderLeft:
                            props.message.Category === "runner"
                              ? "2px solid #888"
                              : "none",
                          borderRight:
                            props.message.Category === "runner"
                              ? "none"
                              : "2px solid #888",
                        }}
                      >
                        <Box className="box-default">
                          <UserAvatar
                            user={{ identity: props.message.parent.UserId }}
                            size="sm"
                            nameOnly={true}
                            nameHideInfo={true}
                          />
                        </Box>
                        <Box className="box-default">
                          <Typography variant="body1" color="white" noWrap>
                            &nbsp;&nbsp;{props.message.parent.ContentData}
                            &nbsp;&nbsp;
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  )}
                  {props.message.ContentModeration ? (
                    <ContentWarningHeaderTag />
                  ) : (
                    <Box
                      className="box-default"
                      sx={{
                        p: configEntzy.APP_SPACING_SM,
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        color="white"
                        sx={{
                          whiteSpace: "pre-line",
                          overflowWrap: "break-word",
                          textAlign:
                            props.message.Category === "runner"
                              ? "right"
                              : "left",
                        }}
                      >
                        {props.message.ContentData}
                      </Typography>
                    </Box>
                  )}
                </Box>
                {/* preview media image display */}
                {props.message.ContentImage && mediaImage.hydrated && (
                  <Box
                    className="box-default"
                    sx={{
                      p: configEntzy.APP_SPACING_MD,
                    }}
                  >
                    <Box
                      className="box-default bg-black-t10 nooverflow"
                      sx={{
                        borderRadius: configEntzy.BORDER_SIZE_XL,
                      }}
                    >
                      <Box className="box-default text-center">
                        <Box className="box-default zero-height">
                          <Box
                            className="box-default nooverflow"
                            sx={{
                              pt: configEntzy.APP_SPACING_SM2X,
                            }}
                          >
                            <span className="fa-layers fa-fw fa-2x">
                              <FontAwesomeIcon
                                icon={iconCircle}
                                color="black"
                                style={{ opacity: 0.6 }}
                              />
                              <FontAwesomeIcon
                                icon={iconPointer}
                                color="white"
                                transform="shrink-8"
                                className="fa-bounce"
                                style={{
                                  "--fa-animation-duration": "1s",
                                  "--fa-animation-iteration-count": 2,
                                }}
                              />
                            </span>
                          </Box>
                        </Box>
                        <Box
                          className="box-default nooverflow"
                          sx={{
                            borderRadius: configEntzy.BORDER_SIZE_XL,
                            height: configEntzy.AVATAR_SIZE_SM,
                          }}
                        >
                          <img
                            src={mediaImage.images.lg.data}
                            alt={mediaImage.key}
                            style={{
                              width: "100%",
                              height: "auto",
                            }}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>
              {/* modal message display */}
              <Modal
                open={popMessage === props.message.PostId}
                onClose={handleClosePopMessage}
              >
                <Box
                  className="box-default bg-black shadow-default"
                  sx={{
                    p: configEntzy.APP_SPACING_MD,
                    borderRadius: configEntzy.BORDER_SIZE_XL,
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    maxHeight: "80%",
                    maxWidth: "80%",
                  }}
                >
                  <Box className="box-default text-right zero-height">
                    <Typography
                      variant="subtitle2"
                      color="primary"
                      sx={{ overflow: "visible" }}
                    >
                      <FontAwesomeIcon
                        icon={iconClose}
                        size="2x"
                        transform="up-40"
                        onClick={handleClosePopMessage}
                      />
                    </Typography>
                  </Box>
                  {/* message display */}
                  <Box
                    className="box-default bg-black shadow-darker"
                    sx={{
                      p: configEntzy.APP_SPACING_MD2X,
                      maxHeight: props.message.ContentImage
                        ? configEntzy.AVATAR_SIZE_LG
                        : configEntzy.AVATAR_CONTAINER_XL,
                      borderRadius: configEntzy.BORDER_SIZE_XL,
                      backgroundColor: "dusk.dark",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <ContentWarningTag
                      moderation={props.message.ContentModeration}
                      contentId={props.message.PostId}
                      showModerated={showModerated}
                      handleShowModerated={handleShowModerated}
                    />
                    <Box className="box-default">
                      <Typography
                        variant="subtitle2"
                        color="white"
                        sx={{
                          whiteSpace: "pre-line",
                          overflowWrap: "break-word",
                        }}
                      >
                        {props.message.ContentModeration ? (
                          showModerated === props.message.PostId ? (
                            <span>{props.message.ContentData}</span>
                          ) : (
                            <span
                              className="content-blur action-pointer"
                              onClick={() =>
                                handleShowModerated(props.message.PostId)
                              }
                            >
                              {props.message.ContentData}
                            </span>
                          )
                        ) : (
                          <Linkify>{props.message.ContentData}</Linkify>
                        )}
                      </Typography>
                    </Box>
                  </Box>
                  {/* media images display */}
                  {props.message.ContentImage && mediaImage.hydrated && (
                    <Box
                      className="box-default nooverflow"
                      sx={{
                        pt: configEntzy.APP_SPACING_MD,
                        borderRadius: configEntzy.BORDER_SIZE_XL,
                      }}
                    >
                      <img
                        src={mediaImage.images.lg.data}
                        alt={mediaImage.key}
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: "6px",
                        }}
                      />
                    </Box>
                  )}
                  <Box
                    className="box-default"
                    sx={{
                      pt: configEntzy.APP_SPACING_SM2X,
                    }}
                  >
                    <MessageUser
                      identity={props.message.UserId}
                      nameOnly={props.message.PostDeleted}
                      light={props.message.PostDeleted ? false : true}
                    />
                  </Box>
                </Box>
              </Modal>
              {/* message post controls */}
              <PostControls
                {...props}
                item={props.message}
                showReply={props.showReply}
                canRemove={canRemove}
                removing={props.removing}
                handleRemoving={props.handleRemoving}
                handleRemove={props.handleRemoveMessage}
              />
            </Box>
          )}
        </Box>
      </Box>
      <Box
        className={
          props.message.Category === "runner"
            ? "box-inline right"
            : "box-inline left"
        }
        sx={{
          width: "40%",
          pt: configEntzy.APP_SPACING_MD,
        }}
      >
        <MessageUser
          identity={props.message.UserId}
          light={!props.message.PostDeleted}
          nameOnly={props.message.PostDeleted}
          nameHideInfo={true}
        />
      </Box>
    </Box>
  );
};

export const NotificationPost = (props) => {
  const runnerSide = props.source === "runner";
  // const riderSide = props.source === "rider";
  const loadingId = props.loadingId;

  return (
    <Box className="box-default">
      {/* ----- loader ----- */}
      {loadingId === props.notification.NotificationId && (
        <Box className="box-default zero-height text-center">
          <Box
            className="box-default"
            sx={{
              pt: configEntzy.APP_SPACING_SM,
            }}
          >
            <ActionLoader size="md" color="secondary" />
          </Box>
        </Box>
      )}
      {/* ----- content item ----- */}

      <Box className="box-default bg-black-t50 shadow-default rounded nooverflow">
        <Box
          className={
            props.handlePopOpenAction
              ? "box-default action-pointer"
              : "box-default"
          }
          sx={{
            p: configEntzy.APP_SPACING_MD,
            textAlign: runnerSide ? "right" : "left",
            color: "white",
          }}
          onClick={props.handlePopOpenAction}
        >
          <Typography variant="subtitle2">
            {props.notification.MessageTitle}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              whiteSpace: "pre-line",
              overflowWrap: "break-word",
              mt: configEntzy.APP_SPACING_SM,
            }}
          >
            {props.notification.MessageBody}
          </Typography>
        </Box>
        {/* message category specific content */}
        {props.notification.MessageCategory === "message:access" && (
          <Box
            className="box-default text-left"
            sx={{
              pl: configEntzy.APP_SPACING_MD,
              pr: configEntzy.APP_SPACING_MD,
              pb: configEntzy.APP_SPACING_MD,
              borderBottomLeftRadius: configEntzy.BORDER_SIZE_LG,
              borderBottomRightRadius: configEntzy.BORDER_SIZE_LG,
            }}
          >
            <Typography variant="body1">
              <em>Tap to jump to the members area</em>
            </Typography>
          </Box>
        )}
        {/* notification post controls */}
        <PostControls
          {...props}
          item={props.notification}
          notification={true}
          canRemove={true}
          removing={props.removing}
          handleRemoving={props.handleRemoving}
          handleRemove={props.handleRemoveNotification}
        />
      </Box>
    </Box>
  );
};
